import { render, staticRenderFns } from "./zen.vue?vue&type=template&id=55f4d32c&scoped=true&"
import script from "./zen.vue?vue&type=script&lang=js&"
export * from "./zen.vue?vue&type=script&lang=js&"
import style0 from "./zen.vue?vue&type=style&index=0&id=55f4d32c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f4d32c",
  null
  
)

export default component.exports